import { render, staticRenderFns } from "./MyPageCustomerService.vue?vue&type=template&id=849d1676&scoped=true&"
import script from "./MyPageCustomerService.vue?vue&type=script&lang=js&"
export * from "./MyPageCustomerService.vue?vue&type=script&lang=js&"
import style0 from "./MyPageCustomerService.vue?vue&type=style&index=0&id=849d1676&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849d1676",
  null
  
)

export default component.exports